import { Injectable } from '@angular/core';

import { OrigamiHttpResponse, ServiceBase } from '@app/origami-api/services/base/service.base';
import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { Observable } from 'rxjs';

export namespace SharedWorkspaceServiceOptions {
  export interface ValidateDocumentAccordanceOptions {
    siteId: number;
    topicId: number;
  }
}

@Injectable()
export class SharedWorkspaceService extends ServiceBase {
  serviceUrl = 'SharedWorkspaceService.svc';

  public validateDocumentAccordance(
    options: SharedWorkspaceServiceOptions.ValidateDocumentAccordanceOptions,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/ValidateDocumentAccordance', options, null, silentErrorCodes, true);
  }
}
